"use strict";
// tslint:disable
/**
 * Unimaze\'s Partner web api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var globalImportUrl = __importStar(require("url"));
var axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
var base_1 = require("./base");
/**
 * DeviceApi - axios parameter creator
 * @export
 */
exports.DeviceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Upload binary data as a body to send in a message.
         * @param {string} messageId
         * @param {string} [transactionGroupIdentifier]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2DevicesUploadPost: function (messageId, transactionGroupIdentifier, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'messageId' is not null or undefined
            if (messageId === null || messageId === undefined) {
                throw new base_1.RequiredError('messageId', 'Required parameter messageId was null or undefined when calling apiV2DevicesUploadPost.');
            }
            var localVarPath = "/api/v2/devices/upload";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (messageId !== undefined) {
                localVarQueryParameter['messageId'] = messageId;
            }
            if (transactionGroupIdentifier !== undefined) {
                localVarQueryParameter['transactionGroupIdentifier'] = transactionGroupIdentifier;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * DeviceApi - functional programming interface
 * @export
 */
exports.DeviceApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Upload binary data as a body to send in a message.
         * @param {string} messageId
         * @param {string} [transactionGroupIdentifier]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2DevicesUploadPost: function (messageId, transactionGroupIdentifier, options) {
            var localVarAxiosArgs = exports.DeviceApiAxiosParamCreator(configuration).apiV2DevicesUploadPost(messageId, transactionGroupIdentifier, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * DeviceApi - factory interface
 * @export
 */
exports.DeviceApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary Upload binary data as a body to send in a message.
         * @param {string} messageId
         * @param {string} [transactionGroupIdentifier]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2DevicesUploadPost: function (messageId, transactionGroupIdentifier, options) {
            return exports.DeviceApiFp(configuration).apiV2DevicesUploadPost(messageId, transactionGroupIdentifier, options)(axios, basePath);
        },
    };
};
/**
 * DeviceApi - object-oriented interface
 * @export
 * @class DeviceApi
 * @extends {BaseAPI}
 */
var DeviceApi = /** @class */ (function (_super) {
    __extends(DeviceApi, _super);
    function DeviceApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Upload binary data as a body to send in a message.
     * @param {string} messageId
     * @param {string} [transactionGroupIdentifier]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceApi
     */
    DeviceApi.prototype.apiV2DevicesUploadPost = function (messageId, transactionGroupIdentifier, options) {
        return exports.DeviceApiFp(this.configuration).apiV2DevicesUploadPost(messageId, transactionGroupIdentifier, options)(this.axios, this.basePath);
    };
    return DeviceApi;
}(base_1.BaseAPI));
exports.DeviceApi = DeviceApi;
/**
 * MessageApi - axios parameter creator
 * @export
 */
exports.MessageApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Access the message using a document reference identifier.
         * @param {string} id A unique identifier to a message document in the form {message-guid}:{participant-identifier-type}:{participant-identifier}:{attachment-index}:{pass-code}
         * @param {string} [ct] Requested content type conversion (pdf, png, jpg, gif, tif, raw), optional. Default is HTML when a stylesheet is available for XML. Raw can be used to return original XML. Otherwise no conversion is made.
         * @param {string} [lang] Requested languages, with fallback options e.g. \&#39;is,en\&#39;. Default is empty.
         * @param {number} [adri] Requested embedded document index. Default is not specified
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2MessagesDisplayByIdGet: function (id, ct, lang, adri, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling apiV2MessagesDisplayByIdGet.');
            }
            var localVarPath = "/api/v2/messages/display/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (ct !== undefined) {
                localVarQueryParameter['ct'] = ct;
            }
            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }
            if (adri !== undefined) {
                localVarQueryParameter['adri'] = adri;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * MessageApi - functional programming interface
 * @export
 */
exports.MessageApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Access the message using a document reference identifier.
         * @param {string} id A unique identifier to a message document in the form {message-guid}:{participant-identifier-type}:{participant-identifier}:{attachment-index}:{pass-code}
         * @param {string} [ct] Requested content type conversion (pdf, png, jpg, gif, tif, raw), optional. Default is HTML when a stylesheet is available for XML. Raw can be used to return original XML. Otherwise no conversion is made.
         * @param {string} [lang] Requested languages, with fallback options e.g. \&#39;is,en\&#39;. Default is empty.
         * @param {number} [adri] Requested embedded document index. Default is not specified
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2MessagesDisplayByIdGet: function (id, ct, lang, adri, options) {
            var localVarAxiosArgs = exports.MessageApiAxiosParamCreator(configuration).apiV2MessagesDisplayByIdGet(id, ct, lang, adri, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * MessageApi - factory interface
 * @export
 */
exports.MessageApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary Access the message using a document reference identifier.
         * @param {string} id A unique identifier to a message document in the form {message-guid}:{participant-identifier-type}:{participant-identifier}:{attachment-index}:{pass-code}
         * @param {string} [ct] Requested content type conversion (pdf, png, jpg, gif, tif, raw), optional. Default is HTML when a stylesheet is available for XML. Raw can be used to return original XML. Otherwise no conversion is made.
         * @param {string} [lang] Requested languages, with fallback options e.g. \&#39;is,en\&#39;. Default is empty.
         * @param {number} [adri] Requested embedded document index. Default is not specified
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2MessagesDisplayByIdGet: function (id, ct, lang, adri, options) {
            return exports.MessageApiFp(configuration).apiV2MessagesDisplayByIdGet(id, ct, lang, adri, options)(axios, basePath);
        },
    };
};
/**
 * MessageApi - object-oriented interface
 * @export
 * @class MessageApi
 * @extends {BaseAPI}
 */
var MessageApi = /** @class */ (function (_super) {
    __extends(MessageApi, _super);
    function MessageApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Access the message using a document reference identifier.
     * @param {string} id A unique identifier to a message document in the form {message-guid}:{participant-identifier-type}:{participant-identifier}:{attachment-index}:{pass-code}
     * @param {string} [ct] Requested content type conversion (pdf, png, jpg, gif, tif, raw), optional. Default is HTML when a stylesheet is available for XML. Raw can be used to return original XML. Otherwise no conversion is made.
     * @param {string} [lang] Requested languages, with fallback options e.g. \&#39;is,en\&#39;. Default is empty.
     * @param {number} [adri] Requested embedded document index. Default is not specified
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageApi
     */
    MessageApi.prototype.apiV2MessagesDisplayByIdGet = function (id, ct, lang, adri, options) {
        return exports.MessageApiFp(this.configuration).apiV2MessagesDisplayByIdGet(id, ct, lang, adri, options)(this.axios, this.basePath);
    };
    return MessageApi;
}(base_1.BaseAPI));
exports.MessageApi = MessageApi;
/**
 * PartnerApi - axios parameter creator
 * @export
 */
exports.PartnerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Returns parties managed by specific partner (by partner identifier).
         * @param {string} managingPartnerIdentifierType
         * @param {string} managingPartnerIdentifier
         * @param {string} [partialName]
         * @param {string} [partialIdentifier]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartnersByManagingPartnerIdentifierTypeByManagingPartnerIdentifierParticipantsGet: function (managingPartnerIdentifierType, managingPartnerIdentifier, partialName, partialIdentifier, offset, limit, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'managingPartnerIdentifierType' is not null or undefined
            if (managingPartnerIdentifierType === null || managingPartnerIdentifierType === undefined) {
                throw new base_1.RequiredError('managingPartnerIdentifierType', 'Required parameter managingPartnerIdentifierType was null or undefined when calling apiV2PartnersByManagingPartnerIdentifierTypeByManagingPartnerIdentifierParticipantsGet.');
            }
            // verify required parameter 'managingPartnerIdentifier' is not null or undefined
            if (managingPartnerIdentifier === null || managingPartnerIdentifier === undefined) {
                throw new base_1.RequiredError('managingPartnerIdentifier', 'Required parameter managingPartnerIdentifier was null or undefined when calling apiV2PartnersByManagingPartnerIdentifierTypeByManagingPartnerIdentifierParticipantsGet.');
            }
            var localVarPath = "/api/v2/partners/{managingPartnerIdentifierType}/{managingPartnerIdentifier}/participants"
                .replace("{" + "managingPartnerIdentifierType" + "}", encodeURIComponent(String(managingPartnerIdentifierType)))
                .replace("{" + "managingPartnerIdentifier" + "}", encodeURIComponent(String(managingPartnerIdentifier)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["partner-api-v2"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (partialName !== undefined) {
                localVarQueryParameter['PartialName'] = partialName;
            }
            if (partialIdentifier !== undefined) {
                localVarQueryParameter['PartialIdentifier'] = partialIdentifier;
            }
            if (offset !== undefined) {
                localVarQueryParameter['Offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['Limit'] = limit;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Gets a list of registered partners.
         * @param {string} [filter]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartnersGet: function (filter, offset, limit, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v2/partners";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["partner-api-v2"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }
            if (offset !== undefined) {
                localVarQueryParameter['Offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['Limit'] = limit;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * PartnerApi - functional programming interface
 * @export
 */
exports.PartnerApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Returns parties managed by specific partner (by partner identifier).
         * @param {string} managingPartnerIdentifierType
         * @param {string} managingPartnerIdentifier
         * @param {string} [partialName]
         * @param {string} [partialIdentifier]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartnersByManagingPartnerIdentifierTypeByManagingPartnerIdentifierParticipantsGet: function (managingPartnerIdentifierType, managingPartnerIdentifier, partialName, partialIdentifier, offset, limit, options) {
            var localVarAxiosArgs = exports.PartnerApiAxiosParamCreator(configuration).apiV2PartnersByManagingPartnerIdentifierTypeByManagingPartnerIdentifierParticipantsGet(managingPartnerIdentifierType, managingPartnerIdentifier, partialName, partialIdentifier, offset, limit, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Gets a list of registered partners.
         * @param {string} [filter]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartnersGet: function (filter, offset, limit, options) {
            var localVarAxiosArgs = exports.PartnerApiAxiosParamCreator(configuration).apiV2PartnersGet(filter, offset, limit, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * PartnerApi - factory interface
 * @export
 */
exports.PartnerApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary Returns parties managed by specific partner (by partner identifier).
         * @param {string} managingPartnerIdentifierType
         * @param {string} managingPartnerIdentifier
         * @param {string} [partialName]
         * @param {string} [partialIdentifier]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartnersByManagingPartnerIdentifierTypeByManagingPartnerIdentifierParticipantsGet: function (managingPartnerIdentifierType, managingPartnerIdentifier, partialName, partialIdentifier, offset, limit, options) {
            return exports.PartnerApiFp(configuration).apiV2PartnersByManagingPartnerIdentifierTypeByManagingPartnerIdentifierParticipantsGet(managingPartnerIdentifierType, managingPartnerIdentifier, partialName, partialIdentifier, offset, limit, options)(axios, basePath);
        },
        /**
         *
         * @summary Gets a list of registered partners.
         * @param {string} [filter]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PartnersGet: function (filter, offset, limit, options) {
            return exports.PartnerApiFp(configuration).apiV2PartnersGet(filter, offset, limit, options)(axios, basePath);
        },
    };
};
/**
 * PartnerApi - object-oriented interface
 * @export
 * @class PartnerApi
 * @extends {BaseAPI}
 */
var PartnerApi = /** @class */ (function (_super) {
    __extends(PartnerApi, _super);
    function PartnerApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Returns parties managed by specific partner (by partner identifier).
     * @param {string} managingPartnerIdentifierType
     * @param {string} managingPartnerIdentifier
     * @param {string} [partialName]
     * @param {string} [partialIdentifier]
     * @param {number} [offset]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerApi
     */
    PartnerApi.prototype.apiV2PartnersByManagingPartnerIdentifierTypeByManagingPartnerIdentifierParticipantsGet = function (managingPartnerIdentifierType, managingPartnerIdentifier, partialName, partialIdentifier, offset, limit, options) {
        return exports.PartnerApiFp(this.configuration).apiV2PartnersByManagingPartnerIdentifierTypeByManagingPartnerIdentifierParticipantsGet(managingPartnerIdentifierType, managingPartnerIdentifier, partialName, partialIdentifier, offset, limit, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Gets a list of registered partners.
     * @param {string} [filter]
     * @param {number} [offset]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerApi
     */
    PartnerApi.prototype.apiV2PartnersGet = function (filter, offset, limit, options) {
        return exports.PartnerApiFp(this.configuration).apiV2PartnersGet(filter, offset, limit, options)(this.axios, this.basePath);
    };
    return PartnerApi;
}(base_1.BaseAPI));
exports.PartnerApi = PartnerApi;
